import { render, staticRenderFns } from "./cartitem.vue?vue&type=template&id=08c57206&scoped=true"
import script from "./cartitem.vue?vue&type=script&lang=js"
export * from "./cartitem.vue?vue&type=script&lang=js"
import style0 from "./cartitem.vue?vue&type=style&index=0&id=08c57206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c57206",
  null
  
)

export default component.exports